(() => {
  const googleWidgetId = 'google-merchantwidget-iframe-wrapper';
  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const googleWidgetScale = 6 / 7;
  let googleWidget;

  const syncGoogleWidget = () => {
    googleWidget ||= document.getElementById(googleWidgetId);
    if (!googleWidget) return false;

    if (mobileQuery.matches) {
      googleWidget.style.setProperty('display', 'none', 'important');
    } else {
      googleWidget.style.removeProperty('display');
      googleWidget.style.setProperty('left', '4px', 'important');
      googleWidget.style.setProperty('bottom', '68px', 'important');
      googleWidget.style.setProperty('transform', `scale(${googleWidgetScale})`, 'important');
      googleWidget.style.setProperty('transform-origin', 'center bottom', 'important');
    }

    return true;
  };

  const start = () => {
    if (!syncGoogleWidget()) {
      const observer = new MutationObserver(() => {
        if (syncGoogleWidget()) observer.disconnect();
      });

      observer.observe(document.body, { childList: true });
    }

    mobileQuery.addEventListener('change', syncGoogleWidget);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
